module.exports = __webpack_public_path__ + "img/30.a8e55ad8.png";